module.exports = __webpack_public_path__ + "img/green1.dd6c8f47.jpg";